import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=d2da91d0&scoped=true&"
import script from "./Sitemap.vue?vue&type=script&lang=js&"
export * from "./Sitemap.vue?vue&type=script&lang=js&"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=d2da91d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2da91d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
